import { parseInboxStage } from './inboxStage';

export const API_HOST = import.meta.env.VITE_API_HOST;
export const BASE_LAMBDA_ENDPOINT = import.meta.env.VITE_BASE_LAMBDA_ENDPOINT;
export const ID_SERVICE = import.meta.env.VITE_ID_SERVICE;
export const LEVEL = import.meta.env.VITE_LEVEL || 'development';
export const SENTRY_DSN = import.meta.env.VITE_SENTRY_DSN;
export const MOCK_JWT = import.meta.env.VITE_MOCK_JWT;
export const AUTH_COOKIE_NAME = import.meta.env.VITE_AUTH_COOKIE_NAME;
export const SHOW_UPCOMING_FEATURES = import.meta.env.VITE_SHOW_UPCOMING_FEATURES === 'true';
export const CENTRIFUGO_URL = import.meta.env.VITE_CENTRIFUGO_URL;
export const REALTIME_TRANSPORT = import.meta.env.VITE_REALTIME_TRANSPORT || 'centrifugo';
export const REALTIME_URL = import.meta.env.VITE_REALTIME_URL;
export const TWILIO_SIGNALING_ENDPOINT = import.meta.env.VITE_TWILIO_SIGNALING_ENDPOINT;
export const GMAIL_SERVICE_URL = import.meta.env.VITE_GMAIL_SERVICE_URL;
export const URL_SHORTENER_ENDPOINT = import.meta.env.VITE_URL_SHORTENER_ENDPOINT;
export const VAPID_PUBLIC_KEY = import.meta.env.VITE_VAPID_PUBLIC_KEY;
export const INBOX_STAGE = parseInboxStage(import.meta.env.VITE_INBOX_STAGE);
